<template>
<Dialog :header="header" 
v-model:visible="$store.state.flows.showclonemodal" 
:breakpoints="{'960px': '75vw', '640px': '100vw'}" :style="{width: '75vw'}"
:modal="true"
>


<div class="grid mt-4">
<div class="col-12 ">
<InputTextValidate :data="fields[0]" :fieldindex="0" @emitValue="inputValueEmitted"></InputTextValidate>
</div>
<div class="col-12 ">
<InputSwitchValidate :data="fields[1]" :fieldindex="1" @emitValue="inputValueEmitted"></InputSwitchValidate>
</div>
<div class="col-12 ">
<InputSwitchValidate :data="fields[2]" :fieldindex="2" @emitValue="inputValueEmitted"></InputSwitchValidate>
</div>
<div class="col-12 ">
<InputSwitchValidate :data="fields[3]" :fieldindex="3" @emitValue="inputValueEmitted"></InputSwitchValidate>
</div>
<div class="col-12 ">
<InputSwitchValidate :data="fields[4]" :fieldindex="4" @emitValue="inputValueEmitted"></InputSwitchValidate>
</div>

</div>




<template #footer>
<Button :label="$store.state.languages.lang_phrases.iptal" icon="pi pi-times" @click="close" class=" p-button-danger p-button-outlined  p-button-sm" :loading="$store.state.ui.submitting"/>
<Button :label="$store.state.languages.lang_phrases.kaydet" icon="pi pi-check" @click="submitForm"  class=" p-button-primary p-button-outlined  p-button-sm"  :loading="submitting"/>
</template>


</Dialog>


</template>

<script>
export default {

  name: 'FlowQuestionlistCloneModal',

  data () {
    return {
    	newname:null,	
    	submitting:false,    	
    	fields:[
	      {
	        title:"Soru Listesi İsmi",
	        key:"name",
	        type:"text",
	        value:null,
	        min_length:2,
	        max_length:50,
	        is_required:true,
	        has_error:false,
	        error_message:null,
	        show:true,
	      },	      
	      {
	        title:"Soruları Kopyala",
	        key:"clone_inputfields",
	        type:"switch",
	        value:false,
	        show:true,
	      },
	      {
	        title:"Boş Bırakma Nedenlerini Kopyala",
	        key:"clone_null_reasons",
	        type:"switch",
	        value:false,
	        show:true,
	      },
	      {
	        title:"Uygunsuzluk Türlerini Kopyala",
	        key:"clone_nonconformities",
	        type:"switch",
	        value:false,
	        show:true,
	      },
	      {
	        title:"Koşulları Kopyala",
	        key:"clone_conditions",
	        type:"switch",
	        value:false,
	        show:true,
	      },
	     ],
    }
  },
  computed:{
  	header()
  	{
  		if(this.$store.state.flows.qu_list_to_clone)
  		{
  			return this.$store.state.flows.qu_list_to_clone.name
  		}
  		else
  		{
  			return ""
  		}
  	},
  	show()
  	{
  		return this.$store.state.flows.showclonemodal
  	},
  },
  watch:{
  	show(newval)
  	{
  		if(newval)
  		{
  			this.submitting = false
  		}
  	},
  },
  methods:{
  	submitForm()
    {

        let validated = this.validateForm(this.fields)
        if(!validated.has_error)
        {
          this.submit()
        }
    },
  	inputValueEmitted(data)
    { 
      this.fields[data.index].value = data.value 
      this.fields[data.index].has_error = false     
    },
  	close()
  	{
  		this.$store.dispatch('flows/setShowCloneModal',false) 
  	},
  	submit()
  	{
  		this.submitting = true
  		this.$emit("questionlistselected",this.fields)
  	},   
  }
}
</script>

<style lang="css" scoped>
</style>